import { RouteConstants } from "../../Core/Constants/RouteConstants";
import type { BookingRecordModel } from "../../Core/Models/BookingModels";
import type {
  CheckoutSessionRequestModel,
  CheckoutSessionResponseModel,
} from "../../Core/Models/PaymentModels";

export const buildCheckoutSessionRequestFn = (
  booking: BookingRecordModel,
  origin: string
): CheckoutSessionRequestModel => ({
  bookingId: booking.id,
  packageId: booking.packageId,
  paymentOption: booking.paymentOption,
  amount: booking.requestedAmount,
  currency: "USD",
  customerEmail: booking.contactEmail,
  successUrl: `${origin}${RouteConstants.paymentSuccess}`,
  cancelUrl: `${origin}${RouteConstants.paymentCancel}`,
  metadata: {
    bookingId: booking.id,
    packageId: booking.packageId,
    shootType: booking.shootType,
  },
});

export const buildMockCheckoutSessionFn = (
  request: CheckoutSessionRequestModel
): CheckoutSessionResponseModel => ({
  sessionId: `mock_${Math.random().toString(36).slice(2, 10)}`,
  checkoutUrl: `${request.successUrl}?session_id=mock_${Math.random()
    .toString(36)
    .slice(2, 10)}&booking_id=${request.bookingId}`,
  provider: "mock",
  amount: request.amount,
  currency: request.currency,
});

export const getPaymentStatusCopyFn = (mode: "success" | "cancel") =>
  mode === "success"
    ? {
        eyebrow: "",
        title: "Booking confirmed.",
        description:
          "Your session hold is secured. CMJ Cinema will use your booking details to prepare the next production steps.",
      }
    : {
        eyebrow: "Checkout canceled",
        title: "Your slot is not confirmed yet.",
        description:
          "Your booking is not reserved until checkout is complete. You can return to the booking page and finish when you are ready.",
      };
